import React from 'react';

export const DraftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_4568_14140"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="25"
        height="25"
      >
        <rect
          x="0.373047"
          y="-0.223389"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4568_14140)">
        <path
          d="M6.37305 21.7766C5.82305 21.7766 5.35221 21.5808 4.96055 21.1891C4.56888 20.7974 4.37305 20.3266 4.37305 19.7766V3.77661C4.37305 3.22661 4.56888 2.75578 4.96055 2.36411C5.35221 1.97244 5.82305 1.77661 6.37305 1.77661H14.373L20.373 7.77661V10.7766C19.9897 10.8599 19.6314 10.9933 19.298 11.1766C18.9647 11.3599 18.6564 11.5933 18.373 11.8766L12.373 17.8516V21.7766H6.37305ZM14.373 21.7766V18.7016L19.898 13.2016C20.048 13.0516 20.2147 12.9433 20.398 12.8766C20.5814 12.8099 20.7647 12.7766 20.948 12.7766C21.148 12.7766 21.3397 12.8141 21.523 12.8891C21.7064 12.9641 21.873 13.0766 22.023 13.2266L22.948 14.1516C23.0814 14.3016 23.1855 14.4683 23.2605 14.6516C23.3355 14.8349 23.373 15.0183 23.373 15.2016C23.373 15.3849 23.3397 15.5724 23.273 15.7641C23.2064 15.9558 23.098 16.1266 22.948 16.2766L17.448 21.7766H14.373ZM20.948 16.1766L21.873 15.2016L20.948 14.2766L19.998 15.2266L20.948 16.1766ZM13.373 8.77661H18.373L13.373 3.77661V8.77661Z"
          fill="#C4964D"
        />
      </g>
    </svg>
  );
};
